import {
  documentsUrls,
  careDirectiveUrls,
  organDonationUrls,
  pdfDownloadUrls,
  sectionStatus,
  SQW_KEY,
  VERSION,
  ADVISOR_KEY,
  checkList,
} from "../../constants/ApiUrls";
import {
  getData,
  postData,
  getXMLData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getHealthcareProxy = async (id) => {
  return await getData(
    SQW_KEY + VERSION + `${id}/${documentsUrls.HEALTHCARE_PROXY}`
  );
};
export const getHealthcareProxyAllQuestions = async (id) => {
  return await getData(
    SQW_KEY + VERSION + `${id}/${documentsUrls.HEALTHCARE_PROXY_ALL_QUESTIONS}`
  );
};
export const postHealthcareProxy = async (payload, id) => {
  return await postData(
    SQW_KEY + VERSION + `${id}/${documentsUrls.HEALTHCARE_PROXY}`,
    payload
  );
};
export const getHealthcareQuestionByCategory = async (type, id) => {
  return await getData(
    SQW_KEY +
      VERSION +
      `${id}/${documentsUrls.HEALTHCARE_PROXY_QUESTIONS_BY_CATEGORY + type}`
  );
};

export const getGuardianOridinance = async (id) => {
  return await getData(
    SQW_KEY + VERSION + `${id}/${documentsUrls.GUARDIAN_ORDINANCE}`
  );
};
export const postGuardianOridinance = async (payload, id) => {
  return await postData(
    SQW_KEY + VERSION + `${id}/${documentsUrls.GUARDIAN_ORDINANCE}`,
    payload
  );
};
export const getCareDirectiveData = async (id) => {
  return await getData(
    SQW_KEY + VERSION + `${id}/${careDirectiveUrls.CARE_DIRECTIVE_DATA}`
  );
};

export const setCareDirectiveData = async (payload, id) => {
  return await postData(
    SQW_KEY + VERSION + `${id}/${careDirectiveUrls.CARE_DIRECTIVE_DATA}`,
    payload
  );
};

export const getOrganDonationData = async (id) => {
  return await getData(
    SQW_KEY + VERSION + `${id}/${organDonationUrls.ORGAN_DONATION_DATA}`
  );
};
export const postOrganDonationData = async (payload, id) => {
  return await postData(
    SQW_KEY + VERSION + `${id}/${organDonationUrls.ORGAN_DONATION_DATA}`,
    payload
  );
};

//pdf download apis
export const downloadPdfHealthProxyApi = async (id, t) => {
  return await getXMLData(
    SQW_KEY + VERSION + `${id}/${pdfDownloadUrls.HEALTH_PROXY}`,
    t("healthcare-proxy"),
    ".pdf"
  );
};
export const downloadPdfGuardiashipOrdinanceApi = async (id, t) => {
  return await getXMLData(
    SQW_KEY + VERSION + `${id}/${pdfDownloadUrls.GUARDIAN_ORDINANCE}`,
    t("guardianship-ordinance"),
    ".pdf"
  );
};
export const downloadPdfCareDirectiveApi = async (id, t) => {
  return await getXMLData(
    SQW_KEY + VERSION + `${id}/${pdfDownloadUrls.CARE_DIRECTIVE}`,
    t("care-directive"),
    ".pdf"
  );
};
export const downloadPdfCustodyOrderApi = async (id, t) => {
  return await getXMLData(
    SQW_KEY + VERSION + `${id}/${pdfDownloadUrls.CUSTODY_ORDER}`,
    t("custody-order"),
    ".pdf"
  );
};
export const downloadPdfOrganDonationApi = async (id, t) => {
  return await getXMLData(
    SQW_KEY + VERSION + `${id}/${pdfDownloadUrls.ORGAN_DOANTION}`,
    t("organ-donation"),
    ".pdf"
  );
};

//section status
export const getSectionStatuses = async (id) => {
  return await getData(
    SQW_KEY + VERSION + `${id}/${sectionStatus.SECTION_STATUS}`
  );
};

// check list
export const getDocumentCheckList = async (id) => {
  return await getData(
    ADVISOR_KEY + VERSION + `${id}/${checkList.GET_CHECK_LIST}`
  );
};

export const updateDocumentCheckList = async (id, payload) => {
  return await updateData(
    ADVISOR_KEY + VERSION + `${id}/${checkList.GET_CHECK_LIST}`,
    payload
  );
};
